import { Button } from "@pdfking/components"
import { PlayIcon } from "lucide-react"
import { useState } from "preact/hooks"

import { RunExample } from "../docs/RunExample"
import type { DocExample } from "../types/DocExample"

/** An example as written, with a Run button and, once run, what it prints as
 * it prints it. The button waits for the run to end; running again starts over. */
export const DocExampleView = ({ example }: { example: DocExample }) => {
  const [output, setOutput] = useState<string[] | undefined>(undefined)
  const [running, setRunning] = useState(false)
  const Run = () => {
    setOutput([])
    setRunning(true)
    void RunExample(example.js, line => setOutput(lines => [...(lines ?? []), line])).then(() =>
      setRunning(false)
    )
  }
  return (
    <div className="flex flex-col overflow-hidden rounded-md border">
      <div className="flex items-center justify-between border-b bg-muted/50 px-3 py-1 text-xs text-muted-foreground">
        Example
        <Button disabled={running} onClick={Run} size="sm" variant="ghost">
          <PlayIcon />
          Run
        </Button>
      </div>
      <pre className="overflow-x-auto bg-muted p-3 font-mono text-sm">{example.ts}</pre>
      {output && (
        <pre className="overflow-x-auto border-t p-3 font-mono text-sm text-muted-foreground">
          {output.join("\n") || (running ? "…" : "(no output)")}
        </pre>
      )}
    </div>
  )
}
